// Helper for fetching, incrementing, and persisting the visitor count
export async function getVisitorCount() {
  try {
    const res = await fetch("/api/counter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    if (res.ok) {
      const data = await res.json();
      if (data && typeof data.count === "number") {
        localStorage.setItem("starcode_visitor_count", String(data.count));
        return data.count;
      }
    }
  } catch (err) {
    console.warn("[STARCODE] Server counter endpoint unavailable, using local fallback:", err);
  }

  // Fallback if running offline / static
  let localCount = parseInt(localStorage.getItem("starcode_visitor_count") || "0", 10);
  localCount++;
  localStorage.setItem("starcode_visitor_count", String(localCount));
  return localCount;
}
